import React from "react";

export default function Footer() {
  return (
    <footer className="pt-4 text-center text-sm">
      Pet project by{" "}
      <a
        className=" text-blue-900 underline"
        href="https://github.com/JeyRathnam"
      >
        Jey
      </a>
      . Data sourced from{" "}
      <a className="text-blue-900 underline" href="https://www.nps.gov">
        NPS
      </a>
    </footer>
  );
}
